var _circle;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgDot = function SvgDot(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 4 4"
  }, props), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 163,
    cy: 45,
    r: 2,
    fill: "#DDE2EB",
    fillRule: "evenodd",
    transform: "translate(-161 -43)"
  })));
};
export default SvgDot;